var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    staticClass: "mt-16",
    attrs: {
      "max-width": "700",
      "width": "100%"
    }
  }, [_c('v-app-bar', {
    attrs: {
      "color": "primary",
      "dark": ""
    },
    scopedSlots: _vm._u([{
      key: "extension",
      fn: function () {
        return [_c('v-tabs', {
          model: {
            value: _vm.tab,
            callback: function ($$v) {
              _vm.tab = $$v;
            },
            expression: "tab"
          }
        }, [_c('v-tabs-slider', {
          attrs: {
            "color": "secondary"
          }
        }), _c('v-tab', [_vm._v(" Hours ")]), _c('v-tab', [_vm._v(" Closings ")])], 1)];
      },
      proxy: true
    }])
  }, [_c('v-toolbar-title', {
    staticClass: "text-h5 font-weight-bold"
  }, [_vm._v("Library Hours & Closings")])], 1), _c('v-card-text', {
    staticClass: "card-text primary--text font-weight-bold pa-1"
  }, [_c('v-tabs-items', {
    model: {
      value: _vm.tab,
      callback: function ($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, [_c('v-tab-item', [_c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_vm._l(_vm.hours, function (hour) {
    return [_c('v-list-item', {
      key: hour.day,
      staticClass: "px-0"
    }, [_c('v-list-item-action', {
      staticClass: "mr-0"
    }, [hour.day === _vm.today ? _c('v-icon', {
      attrs: {
        "color": "primary",
        "small": ""
      }
    }, [_vm._v("mdi-circle")]) : _vm._e()], 1), _c('v-list-item-content', [_c('v-list-item-title', {
      staticClass: "primary--text text-body-1 font-weight-bold"
    }, [_vm._v(_vm._s(hour.day))]), _c('v-list-item-subtitle', {
      staticClass: "text-body-2 font-weight-bold"
    }, [_vm._v(_vm._s(hour.hours))]), _c('v-list-item-subtitle', [_vm._v(_vm._s(hour.note ? ("(" + (hour.note) + ")") : ''))])], 1)], 1), hour.day !== 'Saturday' ? _c('v-divider', {
      key: hour.day + 'd'
    }) : _vm._e()];
  })], 2)], 1), _c('v-tab-item', [_c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_vm._l(_vm.closings, function (data, year) {
    return [_c('v-subheader', {
      key: year + 'h',
      staticClass: "year-subheader text-body-1 primary--text font-weight-bold",
      domProps: {
        "textContent": _vm._s(year)
      }
    }), _c('v-divider', {
      key: ("d1-" + year)
    }), _vm._l(_vm.closings[year], function (closing) {
      return [_c('v-list-item', {
        key: closing.id + year,
        staticClass: "px-0"
      }, [_c('v-list-item-action', {
        staticClass: "mr-0"
      }), _c('v-list-item-content', [_c('v-list-item-title', {
        staticClass: "primary--text text-body-1 font-weight-bold"
      }, [_vm._v(_vm._s(closing.holiday))]), _c('v-list-item-subtitle', {
        staticClass: "text-body-2 font-weight-bold"
      }, [_vm._v(_vm._s(closing.date))]), _c('v-list-item-subtitle', [_vm._v(_vm._s(closing.note ? ("(" + (closing.note) + ")") : ''))])], 1)], 1), _c('v-divider', {
        key: closing.id + year + 'd'
      })];
    })];
  })], 2)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }